var imageHoverText = document.getElementById('imageHoverText');

document.querySelectorAll('.hoverImageText').forEach(function(hoverImage) {
  hoverImage.addEventListener("mousemove", function( event ) {
    //set mouse position on element hover
    var x = event.clientX;
    var y = event.clientY;
    imageHoverText.style.left = `${x+35}px`;
    imageHoverText.style.top = `${y-8}px`;
    imageHoverText.style.display = "block";

    var imageAltText = hoverImage.getAttribute('alt');

    imageHoverText.innerHTML = imageAltText;
  }, false);

  hoverImage.addEventListener("mouseleave", function( event ) {
    imageHoverText.style.display = "none";
  }, false);
});
